export const config = {
    API_KEY : 'AIzaSyCA4ZVrIL1opJv1Nx3Da3coFRcexl_4oo8',
    CAL_ID : 'jonessecretaries@gmail.com',
    CLIENT_ID: '189503141426-r1vht80a6ameihrbuj9fjo7jke3qr3me.apps.googleusercontent.com', 
    CLIENT_SECRET: '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'
  }